/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

const AddFaqPopup = ({
  noteId,
  setNoteId,
  afterPopupclose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const params = useParams();

  const [lessonInput, setlessonInput] = useState("");
  const [lessonList, setlessonList] = useState([]);
  const [noteTitle, setNoteTitle] = useState("");
  const [noteDetails, setNoteDetails] = useState("");
  const [faqNumber, setfaqNumber] = useState("");
  const [lessonValue, setlessonValue] = useState(null);
  const [selectedLessonId, setselectedLessonId] = useState(null);
  const [isPrivate, setisPrivate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!noteTitle.trim()) {
      newErrors.noteTitle = t("Please enter the question for the FAQ.");
    }
    if (!selectedLessonId) {
      newErrors.selectedLessonId = t(
        "Please link this FAQ to a specific lesson."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const lessonInputHandler = (val) => {
    setlessonInput(val);
  };

  const getAllLessons = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_LESSON_LIST_OPTIONS +
        `?courseid=${params.id}&filtertitle=${lessonInput}`;
      const response = await getData(requestURL);
      if (response.status) {
        setlessonList(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const lessonSelectionHandler = (val) => {
    if (val) {
      setlessonValue(val);
      setselectedLessonId(val.value);
    } else {
      setlessonValue(null);
      setselectedLessonId(null);
      setlessonInput("");
      setlessonList([]);
    }
  };

  const getFaqDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_NOTE_DETAILS +
        `/${noteId}`;
      const response = await getData(requestURL);
      if (response.status) {
        setNoteTitle(response.data.title);
        setNoteDetails(response.data.details);
        setfaqNumber(response.data.rank);
        if (response.data?.lessonvalue) {
          lessonSelectionHandler(response.data?.lessonvalue);
        }
        setisPrivate(response.data.isprivate);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const saveFaqHandler = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);
      let noteData = {
        notetype: "2",
        title: noteTitle,
        details: noteDetails,
        rank: faqNumber,
        isprivate: isPrivate,
        course: params.id,
        lessonid: selectedLessonId,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (noteId) {
        requestUrl += url.API_UPDATE_NOTE + `/${noteId}`;
        response = await putData(requestUrl, noteData);
      } else {
        requestUrl += url.API_ADD_NEW_NOTE;
        response = await postData(requestUrl, noteData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        let offCanvasPopup = document.querySelector("#offcanvasAddFaq");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();
        resetHandler();
        afterPopupclose();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setNoteTitle("");
    setNoteDetails("");
    setfaqNumber("");
    setlessonValue(null);
    setselectedLessonId(null);
    setlessonInput("");
    setlessonList([]);
    setNoteId(null);
    setErrors({});
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.selectedLessonId ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.selectedLessonId ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({ ...base, fontSize: "0.875rem" }),
    singleValue: (base) => ({ ...base, fontSize: "0.875rem" }),
  };

  useEffect(() => {
    if (noteId) {
      getFaqDetails();
    }
  }, [noteId]);

  useEffect(() => {
    if (params.id && lessonInput.length > 1) {
      getAllLessons();
    }
  }, [params.id, lessonInput]);

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasAddFaq"
      aria-labelledby="offcanvasAddFaqLabel"
    >
      <div className="offcanvas-header p-4 pb-0">
        <h3 className="offcanvas-title" id="offcanvasAddFaqLabel">
          {noteId ? t("Edit FAQ") : t("Add New FAQ")}
        </h3>
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4 d-flex flex-column h-100">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column flex-grow-1"
          >
            <div className="flex-grow-1">
              <div className="form-group mb-4">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Question")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="question"
                  className={`form-control fs-sm shadow-none ${
                    errors.noteTitle ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., How do I reset my password?")}
                  value={noteTitle}
                  onChange={(e) => {
                    setNoteTitle(e.target.value);
                    if (errors.noteTitle) {
                      setErrors((prev) => ({ ...prev, noteTitle: "" }));
                    }
                  }}
                />
                {errors.noteTitle && (
                  <div className="invalid-feedback d-block">
                    {errors.noteTitle}
                  </div>
                )}
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="answer"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Answer")}
                </label>
                <textarea
                  name="answer"
                  id="answer"
                  cols="30"
                  rows="5"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t(
                    "Provide a clear and concise answer to the question."
                  )}
                  value={noteDetails}
                  onChange={(e) => setNoteDetails(e.target.value)}
                ></textarea>
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="rank"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Rank")}
                </label>
                <input
                  type="number"
                  id="rank"
                  min="1"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("e.g., 1 (determines the display order)")}
                  value={faqNumber}
                  onChange={(e) => setfaqNumber(e.target.value)}
                />
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="lesson"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Lesson")} <span className="text-danger">*</span>
                </label>
                <Select
                  id="lesson"
                  isClearable
                  styles={customStyles}
                  placeholder={t("Search and select a lesson to link this FAQ")}
                  options={lessonList}
                  value={lessonValue}
                  onChange={(val) => {
                    lessonSelectionHandler(val);
                    if (errors.selectedLessonId) {
                      setErrors((prev) => ({ ...prev, selectedLessonId: "" }));
                    }
                  }}
                  onInputChange={lessonInputHandler}
                />
                {errors.selectedLessonId && (
                  <div className="invalid-feedback d-block">
                    {errors.selectedLessonId}
                  </div>
                )}
              </div>

              <div className="form-group mb-4">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    type="checkbox"
                    id="isPrivate"
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    checked={isPrivate}
                    onChange={(e) => setisPrivate(e.target.checked)}
                  />
                  <label htmlFor="isPrivate" className="form-check-label">
                    {t("Mark as Private")}
                  </label>
                </div>
              </div>
            </div>

            <div className="action d-flex justify-content-between gap-3 mt-auto pt-3 border-top">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="offcanvas"
                onClick={resetHandler}
              >
                {t("Cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={saveFaqHandler}
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              >
                {t("Save FAQ")}
                {isSaving && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFaqPopup;
